import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_RECENTLY_UNLISTED_ADDRESSES } from 'api/utilityActionTypes';

export default async function getRecentlyUnlistedAddresses(
  { state, utilityApiClient },
  { utilityPartnerId, forceRefresh = false },
) {
  typeCheck('utilityPartnerId::PositiveNumber', utilityPartnerId);

  const currentPartnerStatePath = [
    'utilityPartnerAddresses',
    'recentlyUnlistedByPartnerId',
    utilityPartnerId,
  ];

  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_RECENTLY_UNLISTED_ADDRESSES,
    queryId: String(utilityPartnerId),
    state: state,
    payload: {
      utilityPartnerId: utilityPartnerId,
    },
    onSuccess(recentlyUnlistedAddresses) {
      if (!recentlyUnlistedAddresses) {
        return;
      }

      state.set(currentPartnerStatePath, recentlyUnlistedAddresses);
    },
  });
}
